<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore()
</script>

<template>
  <div class="background border-slate-800 border">
    <div class="flex justify-center">
      <div class="text-center text-subtext p-1">
        {{ t('map.tooltips.blackHole') }}
      </div>
    </div>
    <div class="flex justify-center items-center blackhole-image relative">
      <img :src="gameStore.cdnUrl + 'images/map/blackhole_orange.webp'" class="w-full h-full object-cover" :alt="t('map.tooltips.blackHole')"/>
      <div class="black-circle"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.blackhole-image {
  height: 9.9rem;
  min-width: 9.9rem;
  overflow: hidden;
}
.black-circle {
  position: absolute;
  width: 70%;
  height: 70%;
  background-color: black;
  border-radius: 50%;
}
.background {
  background-image: url("https://cdn.ferion.com/images/backgrounds/space.webp");
}
</style>
